import {DrugIngredientDTO} from '../../../models/DrugIngredientDTO';
import {NationalDrugDTO} from '../../../models/NationalDrugDTO';
import {AfterViewChecked, ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {FormArray, FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {ActivatedRoute, Router} from '@angular/router';
import {MatDialog} from '@angular/material/dialog';
import {GenericListDialogComponent} from '../../../../common/dialogs/generic-list-dialog/generic-list-dialog.component';
import {AddManufacturerDialogComponent} from '../../dialogs/add-manufacturer-dialog/add-manufacturer-dialog.component';
import {NameValueDTO} from 'src/app/modules/common/models/NameValueDTO';
import {LookupService} from 'src/app/modules/common/services/lookup.service';
import {ManufacturerService} from 'src/app/modules/pbm/services/manufacturer.service';
import {PagedRequestDTO} from 'src/app/modules/common/models/PagedRequestDTO';
import {ManufacturerDTO} from 'src/app/modules/pbm/models/ManufacturerDTO';
import {NationalDrugService} from 'src/app/modules/pbm/services/national-drug.service';
import {KeycloakService} from 'keycloak-angular';
import {MatStepper} from '@angular/material/stepper';
import {ConfirmationDialogComponent} from '../../../../common/dialogs/confirmation-dialog/confirmation-dialog.component';
import {HelpDTO} from 'src/app/modules/other/models/HelpDTO';
import {HelpService} from 'src/app/modules/other/services/help.service';
import {throwError} from 'rxjs';
import {AddMasterDrugViewComponent} from '../add-master-drug-view/add-master-drug-view.component';
import {AddIngredientViewComponent} from '../add-ingredient-view/add-ingredient-view.component';
import {DateUtil} from 'src/app/modules/common/util/DateUtil';
import {createFieldMap} from '../../../../common/util/Util';
import {SharedService} from '../../../../common/services/shared-service';
import {EntityTable} from '../../../../common/types/entity-table.enum';
import {LookupValue} from '../../../../clm/types/lookup-value.enum';

@Component({
  selector: 'app-add-national-drug-view',
  templateUrl: './add-national-drug-view.component.html',
  styleUrls: [
    './add-national-drug-view.component.scss',
    '../../../../../../styles/global/_add-view-edit-styles.scss'
  ]
})
export class AddNationalDrugViewComponent implements OnInit, AfterViewChecked {
  readonly lookupValue = LookupValue;

  regulatorFormControl: FormControl;
  brandNameFormControl: FormControl;
  countryFormControl: FormControl;
  manufacturerFormControl: FormControl;
  nationalDrugCodeFormControl: FormControl;
  registrationOwnerFormControl: FormControl;
  startDateFormControl: FormControl;
  endDateFormControl: FormControl;
  approvalDateFormControl: FormControl;
  statusFormControl: FormControl;
  currencyFormControl: FormControl;
  approvalReferenceFormControl: FormControl;
  originReferenceFormControl: FormControl;

  dosageFormFormControl: FormControl;
  drugNameFormControl: FormControl;
  packPriceFormControl: FormControl;
  packSizeFormControl: FormControl;
  routeOfAdminFormControl: FormControl;

  ingredientFormControl: FormControl;

  masterDrugNameFormControl: FormControl;

  generalFormGroup: FormGroup;
  detailFormGroup: FormGroup;
  ingredientsFormGroup: FormGroup;
  mappingFormGroup: FormGroup;

  regulators: NameValueDTO[];
  currencies: NameValueDTO[];
  statuses: NameValueDTO[];
  countries: NameValueDTO[];
  manufacturers: ManufacturerDTO[];
  dosageForms: NameValueDTO[];
  unitsOfMeasure: NameValueDTO[];
  allIngredients: NameValueDTO[];
  filteredIngredients: NameValueDTO[] = [];
  allRoutes: NameValueDTO[];
  filteredRoutes: NameValueDTO[] = [];
  masterDrugs: NameValueDTO[]; // TODO: Remove master drug lookup
  filteredMasterDrugs: NameValueDTO[] = []; // TODO: Remove master drug lookup
  helpInfo: HelpDTO[];

  userFirstLastName = '';
  dateFormat = DateUtil.dateFormat;
  editNationalDrug = new NationalDrugDTO();
  isEdit = false;

  // Selected objects
  selectedManufacturer: NameValueDTO;

  @ViewChild('stepper') private nationalDrugStepper: MatStepper;
  @ViewChild('packSize') private packSize: ElementRef;

  constructor(
    private changeDetect: ChangeDetectorRef,
    private formBuilder: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    public dialog: MatDialog,
    private keycloakService: KeycloakService,
    private sharedService: SharedService,
    private lookupService: LookupService,
    private manufacturerService: ManufacturerService,
    private nationalDrugService: NationalDrugService,
    private helpService: HelpService
  ) {
    this.regulatorFormControl = new FormControl('');
    this.brandNameFormControl = new FormControl('');
    this.countryFormControl = new FormControl('');
    this.manufacturerFormControl = new FormControl('');
    this.nationalDrugCodeFormControl = new FormControl('');
    this.registrationOwnerFormControl = new FormControl('');
    this.startDateFormControl = new FormControl('');
    this.endDateFormControl = new FormControl('');
    this.approvalDateFormControl = new FormControl('');
    this.statusFormControl = new FormControl('');
    this.currencyFormControl = new FormControl('');
    this.approvalReferenceFormControl = new FormControl('');
    this.originReferenceFormControl = new FormControl('');

    this.generalFormGroup = this.formBuilder.group({
      regulator: this.regulatorFormControl,
      brandName: this.brandNameFormControl,
      country: this.countryFormControl,
      manufacturer: this.manufacturerFormControl,
      nationalDrugCode: this.nationalDrugCodeFormControl,
      registrationOwner: this.registrationOwnerFormControl,
      startDate: this.startDateFormControl,
      endDate: this.endDateFormControl,
      approvalDate: this.approvalDateFormControl,
      status: this.statusFormControl,
      currency: this.currencyFormControl,
      approvalReference: this.approvalReferenceFormControl,
      originReference: this.originReferenceFormControl
    });

    this.dosageFormFormControl = new FormControl('');
    this.drugNameFormControl = new FormControl('');
    this.packPriceFormControl = new FormControl('');
    this.packSizeFormControl = new FormControl('');
    this.routeOfAdminFormControl = new FormControl('');

    this.detailFormGroup = this.formBuilder.group({
      dosageForm: this.dosageFormFormControl,
      drugName: this.drugNameFormControl,
      packPrice: this.packPriceFormControl,
      packSize: this.packPriceFormControl,
      routeOfAdmin: this.routeOfAdminFormControl,
      routes: this.formBuilder.array(
        [],
        [Validators.minLength(1), Validators.maxLength(5)]
      )
    });

    this.ingredientFormControl = new FormControl('');

    this.ingredientsFormGroup = this.formBuilder.group({
      ingredient: this.ingredientFormControl,
      ingredients: this.formBuilder.array(
        [],
        [Validators.minLength(1)]
      )
    });

    this.masterDrugNameFormControl = new FormControl('');

    this.mappingFormGroup = this.formBuilder.group({
      masterDrugName: this.masterDrugNameFormControl
    });
  }

  get routes() {
    return this.detailFormGroup.get('routes') as FormArray;
  }

  get ingredients() {
    return this.ingredientsFormGroup.get('ingredients') as FormArray;
  }

  ngOnInit() {
    if (this.route.snapshot.url[1].path === 'edit-national-drug') {
      this.isEdit = true;
      this.route.paramMap.subscribe((params) => {
        this.getNationalDrug(Number(params.get('id')));
      });
    }

    this.getListOfLookupValues(this.lookupValue.NationalDrugRegulator);
    this.getListOfLookupValues(this.lookupValue.Country);
    this.getListOfLookupValues(this.lookupValue.NationalDrugStatus);
    this.getListOfLookupValues(this.lookupValue.Currency);
    this.getListOfLookupValues(this.lookupValue.DosageForm);
    this.getListOfLookupValues(this.lookupValue.UnitOfMeasure);
    this.getListOfLookupValues(this.lookupValue.Ingredient);
    this.getListOfLookupValues(this.lookupValue.RouteOfAdministration);
    this.getListOfLookupValues(this.lookupValue.MasterDrug);

    this.getHelpInfo('national-drug');

    this.keycloakService.loadUserProfile().then((profile) => {
      this.userFirstLastName = `${profile.firstName} ${profile.lastName}`;
    });
  }

  ngAfterViewChecked(): void {
    this.changeDetect.detectChanges();
  }

  getNationalDrug(nationalDrugId: number) {
    this.nationalDrugService.getNationalDrug(nationalDrugId).subscribe(
      (response) => {
        this.editNationalDrug = response;
        this.populateForms();
        this.onInputChangedGetFilteredListOfManufacturers();
      },
      (errorResponse) => {
        const error = errorResponse.error;
        this.sharedService.openErrorDialog(error.businessMessage);
      }
    );
  }

  populateForms() {
    this.regulatorFormControl.setValue(this.editNationalDrug.regulator.name);
    this.brandNameFormControl.setValue(this.editNationalDrug.brandName);
    this.countryFormControl.setValue(this.editNationalDrug.country);
    this.manufacturerFormControl.setValue(
      this.editNationalDrug.manufacturer != null
        ? this.editNationalDrug.manufacturer.name
        : ''
    );
    this.nationalDrugCodeFormControl.setValue(
      this.editNationalDrug.nationalDrugCode
    );
    this.registrationOwnerFormControl.setValue(
      this.editNationalDrug.registrationOwner
    );
    this.startDateFormControl.setValue(
      new Date(this.editNationalDrug.startDate)
    );
    this.endDateFormControl.setValue(new Date(this.editNationalDrug.endDate));
    this.approvalDateFormControl.setValue(
      this.editNationalDrug.approvalDate != null
        ? new Date(this.editNationalDrug.approvalDate)
        : ''
    );
    this.statusFormControl.setValue(this.editNationalDrug.status.name);
    this.currencyFormControl.setValue(this.editNationalDrug.currency.name);
    this.approvalReferenceFormControl.setValue(
      this.editNationalDrug.approvalReference
    );
    this.originReferenceFormControl.setValue(
      this.editNationalDrug.referenceName
    );
    this.dosageFormFormControl.setValue(this.editNationalDrug.dosageForm.name);
    this.drugNameFormControl.setValue(this.editNationalDrug.drugName);
    this.packPriceFormControl.setValue(this.editNationalDrug.packPrice);
    this.packSizeFormControl.setValue(
      Number(
        this.editNationalDrug.packPrice / this.editNationalDrug.eachPrice
      ).toFixed(2)
    );

    this.editNationalDrug.routesOfAdmin.forEach((route) => {
      this.routes.push(new FormControl(route.name));
    });
    this.editNationalDrug.ingredients.forEach((ingredient) => {
      this.ingredients.push(
        new FormGroup({
          ingredient: new FormControl(ingredient.name),
          strength: new FormControl(ingredient.strength),
          unitOfMeasure: new FormControl(ingredient.unitOfMeasure.name)
        })
      );
    });

    // this.routes.push(new FormControl('Example Route'));
    // this.ingredients.push(new FormGroup({ingredient: new FormControl('Example Ingredient'),strength: new FormControl(500),unitOfMeasure: new FormControl('mg')}))

    this.masterDrugNameFormControl.setValue(
      this.editNationalDrug.masterDrug.name
    );
  }

  onInputChangedFilterRoutes() {
    const filterValue = this.routeOfAdminFormControl.value.toLowerCase();

    if (filterValue.length > 0) {
      this.filteredRoutes = this.allRoutes
        .filter((option) => option.name.toLowerCase().indexOf(filterValue) >= 0)
        .slice(0, 99);
    }
  }

  onInputChangedFilterIngredients() {
    const filterValue = this.ingredientFormControl.value.toLowerCase();

    if (filterValue.length > 0) {
      this.filteredIngredients = this.allIngredients
        .filter((option) => option.name.toLowerCase().indexOf(filterValue) >= 0)
        .slice(0, 99);
    }
  }

  onInputChangedFilterMasterDrugs() {
    const filterValue = this.masterDrugNameFormControl.value.toLowerCase();

    if (filterValue.length > 0) {
      this.filteredMasterDrugs = this.masterDrugs
        .filter((option) => option.name.toLowerCase().indexOf(filterValue) >= 0)
        .slice(0, 99);
    }
  } // TODO: Remove master drug lookup

  getListOfLookupValues(entity: string): void {
    this.lookupService.getListOfLookupValues(entity).subscribe(
      (response: NameValueDTO[]) => {
        if (entity === this.lookupValue.NationalDrugRegulator) {
          this.regulators = response;
        }
        else if (entity === this.lookupValue.Country) {
          this.countries = response;
        }
        else if (entity === this.lookupValue.NationalDrugStatus) {
          this.statuses = response;
        }
        else if (entity === this.lookupValue.Currency) {
          this.currencies = response;
        }
        else if (entity === this.lookupValue.DosageForm) {
          this.dosageForms = response;
        }
        else if (entity === this.lookupValue.UnitOfMeasure) {
          this.unitsOfMeasure = response;
        }
        else if (entity === this.lookupValue.RouteOfAdministration) {
          this.allRoutes = response;
        }
        else if (entity === this.lookupValue.Ingredient) {
          this.allIngredients = response;
        }
        else if (entity == this.lookupValue.MasterDrug) {
          this.masterDrugs = response;
        }
      },
      (errorResponse) => {
        const error = errorResponse.error;
        this.sharedService.openErrorDialog(error.businessMessage);
      }
    );
  }

  getHelpInfo(componentName: string) {
    this.helpService.getListOfHelpInfo(componentName).subscribe(
      (response) => {
        this.helpInfo = response;
      },
      (errorResponse) => {
        const error = errorResponse.error;
        this.sharedService.openErrorDialog(error.businessMessage);
      }
    );
  }

  onInputChangedGetFilteredListOfManufacturers(): void {
    const pagedRequestDTO = new PagedRequestDTO();
    pagedRequestDTO.entityClass = EntityTable.TblManufacturer;
    pagedRequestDTO.pageNumber = 0;
    pagedRequestDTO.pageSize = 100;
    pagedRequestDTO.fieldMap = createFieldMap('name', this.manufacturerFormControl.value);

    this.manufacturerService.getListOfManufacturers(pagedRequestDTO).subscribe(
      (response) => {
        this.manufacturers = response.resultList;
      },
      (errorResponse) => {
        const error = errorResponse.error;
        this.sharedService.openErrorDialog(error.businessMessage);
      }
    );
  }


  calculateIndividualPrice(): number {
    let price = 0;

    if (
      this.packPriceFormControl.value != '' &&
      this.packSizeFormControl.value != '' &&
      this.packSizeFormControl.value != 0
    ) {
      price = this.packPriceFormControl.value / this.packSizeFormControl.value;
    }
    else {
      price = 0;
    }

    return Number(price.toFixed(2));
  }

  addRoute() {
    if (this.routes.length < 5) {
      if (
        this.filteredRoutes.find(
          (item) => item.name === this.routeOfAdminFormControl.value
        ) != null
      ) {
        this.routes.push(new FormControl(this.routeOfAdminFormControl.value));
      }
    }
    else {
      this.sharedService.openSnackBar('Only 5 routes allowed', 'Dismiss');
    }

    this.routeOfAdminFormControl.setValue('');
    this.onInputChangedFilterRoutes();
  }

  removeRoute(index: number) {
    this.routes.removeAt(index);
  }

  addIngredient() {
    if (
      this.filteredIngredients.find(
        (item) => item.name === this.ingredientFormControl.value
      ) != null
    ) {
      const group = new FormGroup({
        ingredient: new FormControl(this.ingredientFormControl.value),
        strength: new FormControl(''),
        unitOfMeasure: new FormControl('')
      });

      this.ingredients.push(group);
    }

    this.ingredientFormControl.setValue('');
    this.onInputChangedFilterIngredients();
  }

  removeIngredient(index: number) {
    this.ingredients.removeAt(index);
  }

  finish() {
    const nationalDrugDTO = new NationalDrugDTO();

    try {
      nationalDrugDTO.masterDrug = this.masterDrugs.find(
        (item) => item.name === this.masterDrugNameFormControl.value
      );
      nationalDrugDTO.referenceName = this.originReferenceFormControl.value;
      nationalDrugDTO.regulator = this.regulators.find(
        (item) => item.name === this.regulatorFormControl.value
      );
      nationalDrugDTO.brandName = this.brandNameFormControl.value;
      nationalDrugDTO.dosageForm = this.dosageForms.find(
        (item) => item.name === this.dosageFormFormControl.value
      );
      nationalDrugDTO.manufacturer = {
        value: this.manufacturers.find(item => item.name === this.manufacturerFormControl.value).manufacturerId,
        name: this.manufacturerFormControl.value
      };
      // nationalDrugDTO.manufacturer = this.selectedManufacturer; //TODO: rather use selectedmanufacturer
      nationalDrugDTO.packPrice = this.packPriceFormControl.value;
      nationalDrugDTO.currency = this.currencies.find(
        (item) => item.name === this.currencyFormControl.value
      );
      nationalDrugDTO.status = this.statuses.find(
        (item) => item.name === this.statusFormControl.value
      );
      nationalDrugDTO.approvalReference = this.approvalReferenceFormControl.value;
      nationalDrugDTO.approvalDate = this.approvalDateFormControl.value;
      nationalDrugDTO.startDate = this.startDateFormControl.value;
      nationalDrugDTO.endDate = this.endDateFormControl.value;
      nationalDrugDTO.nationalDrugCode = this.nationalDrugCodeFormControl.value;
      nationalDrugDTO.registrationOwner = this.registrationOwnerFormControl.value;
      nationalDrugDTO.drugName = this.drugNameFormControl.value;
      nationalDrugDTO.eachPrice = this.calculateIndividualPrice();
      nationalDrugDTO.country = this.countries.find(
        (item) => item.name === this.countryFormControl.value
      ).name;

      const newRoutes: NameValueDTO[] = [];
      this.routes.controls.forEach((control) => {
        newRoutes.push({
          value: this.allRoutes.find((item) => item.name === control.value)
            .value,
          name: control.value
        });
      });
      nationalDrugDTO.routesOfAdmin = newRoutes;

      const newIngredients: DrugIngredientDTO[] = [];
      this.ingredients.controls.forEach((control) => {
        newIngredients.push({
          ingredientId: this.allIngredients.find(
            (item) => item.name === control.value.ingredient
          ).value,
          name: control.value.ingredient,
          strength: control.value.strength,
          unitOfMeasure: {
            value: this.unitsOfMeasure.find(
              (item) => item.name === control.value.unitOfMeasure
            ).value,
            name: control.value.unitOfMeasure
          }
        });
      });
      nationalDrugDTO.ingredients = newIngredients;

      if (this.isEdit) {
        nationalDrugDTO.nationalDrugId = this.editNationalDrug.nationalDrugId;
        nationalDrugDTO.updated = new Date();
        nationalDrugDTO.updatedBy = this.userFirstLastName;
        nationalDrugDTO.created = this.editNationalDrug.created;
        nationalDrugDTO.createdBy = this.editNationalDrug.createdBy;
      }
      else {
        nationalDrugDTO.created = new Date();
        nationalDrugDTO.createdBy = this.userFirstLastName;
      }

      this.nationalDrugService.saveNationalDrug(nationalDrugDTO).subscribe(
        (response) => {
          this.sharedService.openSnackBar(
            `National drug ${response.brandName} saved successfully`,
            'Dismiss'
          );
          this.router.navigate(['/pharmacy-management'], {queryParams: {tab: 'national-drugs'}});
        },
        (error) => {
          throwError(error);
        }
      );
    } catch (e) {
      this.sharedService.openErrorDialog((e as Error).message);
      this.nationalDrugStepper.selectedIndex = 0;
    }
  }

  openDialog(displayHeading: string): void {
    const displayList: string[] = [];

    if (displayHeading === 'Ingredients(s)') {
      displayList.push('Ingredient;Strength;Unit of Measure');
      const ingredientGrpList = this.ingredients.controls;
      for (let i = 0; i < ingredientGrpList.length; i++) {
        const displayString = `${ingredientGrpList[i].value.ingredient};${ingredientGrpList[i].value.strength};${ingredientGrpList[i].value.unitOfMeasure}`;
        displayList.push(displayString);
      }
    }
    else if (displayHeading === 'Route(s) of Administration') {
      const routeList = this.routes.controls;
      for (let i = 0; i < routeList.length; i++) {
        const displayString = routeList[i].value;
        displayList.push(displayString);
      }
    }

    const dialogRef = this.dialog.open(GenericListDialogComponent, {
      width: '40vw',
      data: {list: displayList, heading: displayHeading}
    });
  }

  openManufacturerDialog() {
    const dialogRef = this.dialog.open(AddManufacturerDialogComponent, {
      width: '40vw'
    });
  }

  openMasterDrugDialog() {
    const isDialog = true;
    const dialogRef = this.dialog.open(AddMasterDrugViewComponent, {
      width: '80vw',
      data: isDialog
    });
  }

  openIngredientDialog() {
    const isDialog = true;
    const dialogRef = this.dialog.open(AddIngredientViewComponent, {
      width: '80vw',
      data: isDialog
    });
  }

  detailNext() {
    if (this.packSizeFormControl.value > 1000) {
      const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
        width: '40vw',
        data:
          'The pack size is greater than 1000. Are you sre you wish to proceed?'
      });

      dialogRef.afterClosed().subscribe((result) => {
        const isConfirmed = result;

        if (isConfirmed) {
          this.nationalDrugStepper.next();
        }
        else {
          this.packSizeFormControl.reset();
          this.packSize.nativeElement.focus();
        }
      });
    }
    else {
      this.nationalDrugStepper.next();
    }
  }

  ingredientNext() {
    let canContinue = true;

    const ingredientGrpList = this.ingredients.controls;
    for (let i = 0; i < ingredientGrpList.length; i++) {
      if (ingredientGrpList[i].value.strength > 1000) {
        canContinue = false;

        const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
          width: '40vw',
          data:
            'The ingredient strength of one or more ingredients is greater than 1000. Are you sre you wish to proceed?'
        });

        dialogRef.afterClosed().subscribe((result) => {
          const isConfirmed = result;

          if (isConfirmed) {
            this.nationalDrugStepper.next();
          }
          else {
            ingredientGrpList[i].value.strength.reset();
          }
        });

        break;
      }
    }
    if (canContinue) {
      this.nationalDrugStepper.next();
    }
  }

  blurManufacturer() {
    if (
      this.manufacturers.find(
        (item) => item.name === this.manufacturerFormControl.value
      ) == null
    ) {
      this.manufacturerFormControl.reset();
      this.selectedManufacturer = null;
    }
  }

  manufacturerSelected(event: any) {
    const name = event.source.value;
    this.selectedManufacturer = {
      value: this.manufacturers.find((item) => item.name === name)
        .manufacturerId,
      name
    };
  }

  countrySelected(event: any) {
    const name = event.source.value;
    const id = this.countries.find((item) => item.name === name).value;
    // Todo: use country is to select a currency
  }

  getInfoTooltip(inputName: string): string {
    let message = '';
    if (this.helpInfo != null) {
      const helpInfo = this.helpInfo.find((help) => help.inputName === inputName);
      message = helpInfo != null ? helpInfo.inputInfo : '';
    }
    return message;
  }
}
